
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'
import FormTextInput from './FormTextInput'
import FormPrice from './FormPrice'
import FormSelectInput from './FormSelectInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormEmployeeSalaryDetail = ({
  colSize,
  inputLabel,
  className,
  salaryDetails,
  handleAddEmployeeSalaryDetails,
  errors,
  handleChangeSalaryDetails,
  handleRemoveEmployeeSalaryDetails,
  disabled,
  salaryTypeOptions,
  lastAccordionRef,
  activeAccordionKey,
  setActiveAccordionKey
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel className='fs-6 fs-md-3'>
          {inputLabel}
        </CFormLabel>
        {
          !disabled && (
            <CButton
              onClick={() => handleAddEmployeeSalaryDetails()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {salaryDetails?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {salaryDetails?.length > 0 && (
        salaryDetails?.map((inputField, index) => {
          let isDeduction = inputField?.is_deduction || false
          let itemKey = index + 1
          let isActive = activeAccordionKey === itemKey
          
          return (
            <CAccordion
              key={`accordion-${itemKey}-${salaryDetails.length}`} // Tambahkan length untuk force re-render
              alwaysOpen={false} 
              activeItemKey={isActive ? itemKey : null} 
              ref={index === salaryDetails.length - 1 ? lastAccordionRef : null}
            >
              <CAccordionItem itemKey={itemKey} className='mb-2'>
                <CAccordionHeader onClick={() => setActiveAccordionKey(isActive ? null : itemKey)}>Detail {index + 1}{inputField.detail_name ? `: ${inputField.detail_name}` : null}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Title
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='detail_name'
                        name='detail_name'
                        colSize='6'
                        placeholder='Enter detail name...'
                        value={inputField.detail_name}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeSalaryDetails(e, index)}
                        feedbackInvalid={!disabled && errors.employee_salary_details?.length > 0 ? errors?.employee_salary_details[index].detail_name : null}
                        invalid={!disabled && errors.employee_salary_details?.length > 0 ? errors?.employee_salary_details[index].detail_name : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Value
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormPrice
                        id='detail_value'
                        name='detail_value'
                        colSize='6'
                        placeholder='Enter detail value...'
                        value={inputField.detail_value}
                        handlePriceInput={(e) => handleChangeSalaryDetails(e, index)}
                        feedbackInvalid={!disabled && errors.employee_salary_details?.length > 0 ? errors?.employee_salary_details[index].detail_value : null}
                        invalid={!disabled && errors.employee_salary_details?.length > 0 ? errors?.employee_salary_details[index].detail_value : null}
                        disabled={disabled}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel className='fs-6 fs-md-3'>
                        Type
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormSelectInput 
                        id='is_deduction'
                        name='is_deduction'
                        colSize='6'
                        isShowLabel={false}
                        selectOptions={salaryTypeOptions}
                        value={salaryTypeOptions?.filter((val) => val?.value == isDeduction)[0]}
                        handleSelectInput={(e) => handleChangeSalaryDetails(e, index, 'is_deduction')}
                        feedbackInvalid={errors.is_deduction}
                        invalid={errors.is_deduction}
                        disabled={false}
                        multiple={false}
                        placeholder='Please select type salary...'
                      />
                    </CCol>
                  </CRow>
                  {
                    salaryDetails?.length > 1 && !disabled && (
                      <CButton
                        style={styleButtonVars2}
                        onClick={() => {handleRemoveEmployeeSalaryDetails(inputField, index)}}
                      >
                        Delete Detail
                      </CButton>
                    )
                  }
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          )
        })
      )}
    </CCol>
  )
}

export default FormEmployeeSalaryDetail
